import React from "react";
import VerticalDivider from "@components/ui/vertical_divider";
import clearLogo from "@images/clear_logo_horizontal.png";
import greenhouseLogo from "@images/greenhouse_logo.svg";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
};

const ClearModalHeader: React.FC<Props> = ({ className = "" }) => {
  return (
    <div className={cn("flex items-center justify-center mb-8 w-full", className)}>
      <img src={greenhouseLogo} alt="My Greenhouse Logo" className="h-8 mr-6" />
      <VerticalDivider />
      <img src={clearLogo} alt="CLEAR Logo" className="h-8 ml-6" />
    </div>
  );
};

export default ClearModalHeader;
